import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import weforsys from '@/utils/weforsys';
import elementEnLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang
import enLocale from "./en";
import zhLocale from "./zh";
import zhtwLocale from "./zhtw";
Vue.use(VueI18n);
var messages = {
  zh: _objectSpread(_objectSpread({}, zhLocale), elementZhLocale),
  en: _objectSpread(_objectSpread({}, enLocale), elementEnLocale),
  zhtw: _objectSpread(_objectSpread({}, zhtwLocale), elementZhTWLocale)
};
export function getLanguage() {
  var chooseLanguage = weforsys.storageGet('language');
  if (chooseLanguage) return chooseLanguage;

  // if has not choose language
  var language = (navigator.language || navigator.browserLanguage).toLowerCase();
  if (language.indexOf('tw') > -1) return 'zhtw';
  var locales = Object.keys(messages);
  for (var _i = 0, _locales = locales; _i < _locales.length; _i++) {
    var locale = _locales[_i];
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return 'zh';
}
var i18n = new VueI18n({
  // options: zh | zhtw | en
  locale: getLanguage(),
  silentTranslationWarn: true,
  // set locale messages
  messages: messages
});
export default i18n;